import React from 'react';
import PropTypes from 'prop-types';
import JourneyProp from '../../journey/propTypes/journeyProp';
import JourneyItem from './JourneyItem';

export default function Journeys({ journeys }) {
  return (
    <div className="landing-journey-container">
      <hr className="divider-session" />
      {journeys.map((journey, index) => (
        <JourneyItem
          key={journey._id}
          journey={journey}
          isFlipped={!(index % 2 === 0)}
        />
      ))}
      <hr className="divider-session" />
    </div>
  );
}

Journeys.propTypes = {
  journeys: PropTypes.arrayOf(PropTypes.shape(JourneyProp.propType)).isRequired,
};
